export default {
  root: {
    marginBottom: 32
  }
}
